import { request } from '../../request';
import { ShiftRotationUpdate } from '@libs/models/shifts';

export async function createShiftRotation(data: ShiftRotationUpdate): Promise<RotationCreationResult[]> {
  const response = await request.post<RotationCreationResult[]>('/v2/shifts/rotation', {
    ...data,
    specialityId: data.specialtyId || null,
    subDepartmentNodeId: data.subDepartmentNodeId || null,
    departmentNodeId: data.departmentNodeId || null,
    startDate: { dateTime: data.startDate, timeZone: data.timeZone },
    endDate: { dateTime: data.endDate, timeZone: data.timeZone },
    dateTimeSlots: data.dateTimeSlots.map((slot) => ({
      startDate: { dateTime: slot.startDate, timeZone: data.timeZone },
      endDate: { dateTime: slot.endDate, timeZone: data.timeZone },
    })),

    tags: data.tags.reduce((acc, tag) => {
      if (tag) {
        acc.push(tag + '');
      }
      return acc;
    }, [] as string[]),
  });
  return response.data;
}

type RotationCreationResult = {
  id: string; //'shiftrecurrence-00000000000000000000000000';
  shiftIds: string[]; //['shift-00000000000000000000000000'];
  isArcive: boolean;
};
